/**
 * created by yxy
 * 此组件为列表组件
 * 引用此组件需要传dataSource，columns，start,size
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Table, Pagination, Empty} from 'antd';
// import Btn from "./btn/Btn";
import './TableComponents.css'


export default class TabComponent extends Component {
    static defaultProps = {
        dataSource: [
            {
                key: '1',
                name: '胡彦斌',
                age: 32,
                address: '西湖区湖底公园1号',
            },
            {
                key: '2',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园1号',
            },
        ],
        columns: [
            {
                title: '姓名',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '年龄',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '住址',
                dataIndex: 'address',
                key: 'address',
            },
        ],
        state: 1,
        size: 10,
        count: 0,
        onChange: () => {
            console.log(1)
        },

    };
    static propTypes = {
        dataSource: PropTypes.array.isRequired,//传入的数据
        columns: PropTypes.array.isRequired,//传入的columns
        state: PropTypes.string.isRequired,//第几页
        size: PropTypes.string.isRequired,//一页显示多少个
        count: PropTypes.string.isRequired,//总共多少条数据
        onChange: PropTypes.func.isRequired,//点击页数的方法
    };

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
    }
    componentDidMount() {
    }

    render() {
        return (
            <div>
                {/*列表*/}
                {this.tabList()}
                {/*  分页  */}
                {this.Pagination()}
            </div>
        )
    }
    //列表组件
    tabList() {

        let columns = this.props.columns;
        return (
            <div>
                {this.props.dataSource && this.props.dataSource.length ? <Table pagination={false}
                                                                                className={"tabList"}
                                                                                dataSource={this.props.dataSource}
                                                                                columns={columns}
                                                                                rowKey="id"
                                                                                rowClassName={this.getRowClassName}/> :
                    <div style={{padding: '200px'}}><Empty/></div>}

            </div>
        )
    }

    //分页组件
    Pagination() {
        return (
            <div style={{display: 'flex', justifyContent: 'right',marginTop:'20px'}}>
                {
                    this.props.count && this.props.count > 0 ? <Pagination current={this.props.start}
                                                                            showQuickJumper
                                                                           pageSize={this.props.size}
                                                                           total={this.props.count}
                                                                           showTotal={total => `共 ${total} 条`}
                                                                           // showSizeChanger
                                                                           onChange={(page, pageSize) => {
                                                                               this.props.onChange && this.props.onChange(page, pageSize)
                                                                           }}
                                                                           onShowSizeChange={(page, pageSize) => {
                                                                               this.props.onChange && this.props.onChange(page, pageSize)
                                                                           }}/> : null
                }

            </div>
        )
    }

    //表格行背景色
    getRowClassName = (record, index) => {
        let className = '';
        className = index % 2 === 0 ? "evenRow" : "oddRow";
        return className;
    };
}
